<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Add Employee</span>
  <form
    [formGroup]="form"
    (ngSubmit)="submit()"
    class="w-full flex flex-col gap-6 mt-6 p-4 lg:flex-row lg:gap-8"
  >
    <div class="w-full lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div class="flex flex-col space-y-2">
        <span class="font-medium">First Name</span>
        <input
          type="text"
          formControlName="firstName"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nama depan"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Last Name</span>
        <input
          type="text"
          formControlName="lastName"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nama belakang"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Gender</span>
        <mat-select
          placeholder="Pilih jenis kelamin"
          class="h-12 rounded-lg px-4 py-3 text-sm text-[#5C5C5C] border border-gray-200 focus:outline-none !font-display"
          formControlName="gender"
        >
          <mat-option class="!font-display" value="Laki-laki"
            >Laki-laki</mat-option
          >
          <mat-option class="!font-display" value="Perempuan"
            >Perempuan</mat-option
          >
        </mat-select>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Identity Number (KTP/Passport)</span>
        <input
          type="text"
          formControlName="identityNumber"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nomor identitas"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Date Birth</span>
        <input
          type="date"
          formControlName="birthDate"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
         placeholder="Pilih tanggal lahir"/>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Place of Birth</span>
        <input
          type="text"
          formControlName="placeOfBirth"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan tempat lahir"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Email</span>
        <input
          type="text"
          formControlName="email"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan email"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Phone</span>
        <input
          type="text"
          formControlName="phone"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nomor telepon"
        />
      </div>
      <div class="col-span-1 sm:col-span-2 py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Employee ID</span>
        <input
          type="text"
          formControlName="employeeId"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan ID karyawan"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Position</span>
        <mat-select
          placeholder="Pilih posisi"
          formControlName="position"
          class="h-12 rounded-lg px-4 py-3 text-sm text-[#5C5C5C] border border-gray-200 focus:outline-none"
        >
          <ng-container *ngFor="let item of positions">
            <mat-option [value]="item.name">{{ item.name }}</mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Status Employment</span>
        <input
          type="text"
          formControlName="statusEmployment"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan status kepegawaian"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Team</span>
        <mat-select
          placeholder="Pilih team"
          class="h-12 rounded-lg px-4 py-3 text-sm text-[#5C5C5C] border border-gray-200 focus:outline-none"
          formControlName="teamId"
        >
          <ng-container *ngFor="let item of teams">
            <mat-option [value]="item.id">{{ item.name }}</mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Join Date</span>
        <input
          type="date"
          [attr.max]="form.get('endDate')?.value || null"
          formControlName="joinDate"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Pilih tanggal bergabung"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">End Date</span>
        <input
          type="date"
          [attr.min]="form.get('joinDate')?.value || null"
          formControlName="endDate"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Pilih tanggal berakhir"
        />
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Roles</span>
        <mat-select
          placeholder="Pilih role"
          class="h-12 rounded-lg px-4 py-3 text-sm text-[#5C5C5C] border border-gray-200 focus:outline-none"
          formControlName="rolesId"
          [multiple]="true"
        >
          <ng-container *ngFor="let item of roles">
            <mat-option [value]="item.id">{{ item.name }}</mat-option>
          </ng-container>
        </mat-select>
      </div>
      <div class="col-span-1 sm:col-span-2 py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Bank Name</span>
        <input
          type="text"
          formControlName="bankName"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nama bank"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Bank Account Name</span>
        <input
          type="text"
          formControlName="bankAccountName"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nama pemilik rekening"
        />
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Bank Account Number</span>
        <input
          type="text"
          formControlName="bankAccountNumber"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan nomor rekening"
        />
      </div>
      <div class="flex flex-col space-y-2 col-span-1 sm:col-span-2">
        <span class="font-medium">Maximum Amount Cash Advance</span>
        <input
          type="text"
          formControlName="maximumAmount"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan maks. cash advance"
        />
      </div>
      <div class="col-span-1 sm:col-span-2 py-6">
        <mat-divider class="!border-gray-300"></mat-divider>
      </div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Password</span>
        <input
          type="password"
          formControlName="password"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan password"
        />
      </div>
      <div></div>
      <div class="flex flex-col space-y-2">
        <span class="font-medium">Re-Enter Password</span>
        <input
          type="password"
          formControlName="confirmPassword"
          class="h-12 rounded-lg text-sm p-4 text-[#5C5C5C] border border-gray-200 focus:outline-none"
          placeholder="Masukkan ulang password"
        />
      </div>
      <div></div>
      <div class="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 mt-8 col-span-1 sm:col-span-2">
        <button
          [disabled]="
            form.invalid ||
            form.get('password')?.value != form.get('confirmPassword')?.value
          "
          class="w-full sm:w-80 h-12 rounded-lg bg-[#85E2B1] text-white flex items-center justify-center space-x-2"
        >
          <span>Save</span>
        </button>
        <button
          type="button"
          (click)="cancel()"
          class="w-full sm:w-80 h-12 rounded-lg bg-gray-400 text-white flex items-center justify-center space-x-2"
        >
          <span>Cancel</span>
        </button>
      </div>
    </div>
    <div class="w-full lg:w-1/3 flex flex-col space-y-2">
      <span class="font-medium">Photo</span>
      <input
        type="file"
        accept="image/*"
        #profile
        name="profile_photo"
        class="hidden"
        (change)="uploadImage($event)"
      />
      <div
        (click)="profile.click()"
        class="h-72 sm:h-96 w-full sm:w-72 rounded-lg border border-gray-200 flex items-center justify-center cursor-pointer"
      >
        <img
          *ngIf="!uploadStatus && imageUrl"
          [src]="imageUrl || 'profile.png'"
          alt="Foto Profil"
          class="h-full w-full rounded-lg border object-cover border-gray-200 cursor-pointer"
        />
        <i
          class="fa-solid fa-camera text-6xl"
          *ngIf="!uploadStatus && !imageUrl"
        ></i>
        <i
          class="fa-solid fa-spinner text-6xl animate-spin"
          *ngIf="uploadStatus"
        ></i>
      </div>
      <button
        (click)="profile.click()"
        type="button"
        class="w-full sm:w-72 h-12 flex items-center justify-center rounded-lg border border-gray-400"
      >
        Browse File
      </button>
    </div>
  </form>
</section>
